import loadable from '@loadable/component';

// 懒加载组件
import { subRoutes as SupOperationRoutes } from './supOperation/SupOperationModule';
const LicenseManagement = loadable(() => import('./supLicense/licenseManagement/LicenseManagement'));
const DocumentLicenseManagement = loadable(() => import('./supLicense/documentLicenseManagement/DocumentLicenseManagement'));
const ProductDocumentLicenseManagement = loadable(() => import('./supLicense/productLicenseView/productDocLicManage/DocumentLicenseManagement'));
const FactoryManagement = loadable(() => import('./supLicense/factoryManagement/FactoryManagement'));
const AgentManagement = loadable(() => import('./supLicense/agentManagement/AgentManagement'));
const ProductLicenseManagement = loadable(() => import('./supLicense/productLicenseManagement/ProductLicenseManagement'));
const ItemLicenseNewApplication = loadable(() => import('./supProduct/itemLicenseNewApplication/ItemLicenseNewApplication'));
const FactoryApplictionManagement = loadable(() => import('./supProduct/factoryNewApplication/FactoryManagement'));
const CstStatementManagement = loadable(() => import('./supCost/cstStatementManagement/CstStatementManagement'));
const CstStatementModify = loadable(() => import('./supCost/cstStatementManagement/cstStatementModify/CstStatementModify'));

export const subRoutes = [
  ...SupOperationRoutes,
  {
    path: '/ProductDocumentLicenseManagement',
    component: ProductDocumentLicenseManagement
  },
  {
    path: '/LicenseManagement',
    component: LicenseManagement
  },
  {
    path: '/DocumentLicenseManagement',
    component: DocumentLicenseManagement
  },
  {
    path: '/FactoryManagement',
    component: FactoryManagement
  },
  {
    path: '/ProductLicenseManagement',
    component: ProductLicenseManagement
  },
  {
    path: '/AgentManagement',
    component: AgentManagement
  },
  {
    path: '/ItemLicenseNewApplication',
    component: ItemLicenseNewApplication
  },
  {
    path: '/FactoryApplictionManagement',
    component: FactoryApplictionManagement
  },
  {
    path: '/CstStatementManagement',
    component: CstStatementManagement
  },
  {
    path: '/CstStatementModify',
    component: CstStatementModify
  }
];
